module.exports = __webpack_public_path__ + "img/logo-dark.78c66f70.svg";